import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import Button from '../Button/Button';
import Form from '../Form';
import { Modal } from '../Modal';
import TextArea from '../TextArea';
import { CommentModalDialogProps } from './types';


export function CommentModalDialog({ isOpen, onClose, comment, action }: CommentModalDialogProps) {
    const [localComment, setLocalComment] = useState(comment);

    useEffect(() => {
        setLocalComment(comment);
    }, [comment])

    return <Modal isOpen={isOpen} onClose={onClose}>
        <Form action="#" className="order__comment">
            <div className="order__comment-heading"><Trans>Comment</Trans></div>
            <p className="order__comment-copy"><Trans>The comment will be visible only to you</Trans></p>
            <div className="order__comment-input">
                <TextArea value={localComment} onChange={(e) => setLocalComment(e.target.value)} />
            </div>
            <div className="order__comment-actions">
                <Button className="order__comment-actions-submit" type="button" onClick={() => { action(localComment); onClose(); }}>
                    <Trans>Save</Trans>
                </Button>
                {comment && <span className="order__comment-actions-cancel" onClick={() => { action(''); onClose(); }}><Trans>Delete</Trans></span>}
            </div>
        </Form>
    </Modal>
}
